import React from 'react'
import axios from 'axios';
import { Snackbar, SnackbarContent, Button } from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import BorderColorRoundedIcon from '@material-ui/icons/BorderColorRounded';
import { Redirect } from "react-router-dom";
import queryString from 'query-string'
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import whatsappLink from '../whatsappLink'
import ReplayIcon from '@material-ui/icons/Replay'




import style from 'style/login.css'
import Header from 'components/Header'
import utils from 'Utils'
import Matrix from '../scripts/Matrix'
import Loading from 'components/Loading'


class Login extends React.Component {

  constructor(props) {
    super(props)
    const parsed = queryString.parse(this.props.location.search);
    this.captchaBtn = React.createRef()
    // console.log(parsed)
    const consultRequestId = parsed.consultId || null
    this.state = {
      usernameVal: '',
      smsCodeVal: '',
      open: false,
      snackMessage: ' ',
      loading: false,
      formStep: 1,
      redirect: '',
      tempToken: '',
      consultRequestId,
      signupForm: {
        fname: '',
        lname: '',
        nationalId: '',
        gender: 'true',
        isAtba: false,
        email: ''
      },
      captcha: {
        svg: '',
        hash: ''
      }
    }
  }

  componentDidMount() {
    if (Matrix.isLoggedIn()) this.setState({ redirect: this.redirectToChatURL() })

    this.apiGetCaptcha()
  }
  redirectToChatURL = () => {
    return { pathname: '/chats', state: { consultId: this.state.consultRequestId } }
  }
  handleChange = (event) => {
    let obj = {}
    obj[`${event.target.name}Val`] = utils.faTOen(event.target.value)
    this.setState(obj);
  }
  sendNumber = async () => {
    this.setState({ loading: true })
    let result = await axios.post(utils.urls.sendNumberURL, {
      'username': this.state.usernameVal,
      captchaHash: this.state.captcha.hash,
      captchaValue: this.state.captchaCodeVal
    }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.openSnackbar(message)

    });
    this.setState({ loading: false })

    if (!result) return this.apiGetCaptcha()
    // console.log(result)
    if (result.data.success) {
      await this.setState({
        formStep: 2,
        captcha: {
          svg: '',
          hash: ''
        },
        captchaCodeVal: ''
      })

      this.apiGetCaptcha()
    }
  }
  sendCode = async () => {
    this.setState({ loading: true })
    let result = await axios.get(utils.urls.sendNumberURL + (this.state.captcha.hash ? `?captchaHash=${this.state.captcha.hash}&captchaValue=${this.state.captchaCodeVal}` : ''), {
      auth: {
        username: this.state.usernameVal.trim(),
        password: encodeURIComponent(this.state.smsCodeVal.trim()),
        captchaHash: this.state.captcha.hash,
        captchaValue: this.state.captchaCodeVal
      }
    }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return this.apiGetCaptcha()

    if (!result.data.success) {
      this.apiGetCaptcha()
      return this.openSnackbar('خطایی رخ داده است')
    }

    // console.log(result)
    let { token, roles, userObj, matrixUser, blogToken, isPatient } = result.data;
    const mainRole = utils.getMainRole(roles)
    localStorage.setItem("mainRole", mainRole);
    if (matrixUser) {
      localStorage.setItem("n_matrix", JSON.stringify(matrixUser));
      // localStorage.setItem("msgToken", matrixUser['access_token']);
      Matrix.setAccessToken(matrixUser['access_token'])
    }
    // localStorage.setItem("token", token);
    // localStorage.setItem("userId", userObj.userName);

    Matrix.setUserId(userObj.userName)
    localStorage.setItem("blogToken", blogToken);

    if (!(mainRole === 'patient' && !isPatient)) { // if user is patient and ispatient is false then dont set token - is tempToken
      Matrix.setToken(token)
      setTimeout(() => this.setState({ redirect: this.redirectToChatURL() }), 100)
    } else {
      this.setState({ tempToken: token, formStep: 3 })
    }

  }
  openSnackbar = (message) => {
    this.setState({ snackMessage: message, open: true });
  }
  handleClose = () => {
    this.setState({ open: false });
  };

  closeAction = (
    <Button style={{ color: "#fff", 'min-width': 'auto', padding: 0 }} onClick={this.handleClose} >
      <CloseRoundedIcon></CloseRoundedIcon>
    </Button>
  );
  wrongNumber = () => {
    this.setState({ formStep: 1 })
  }
  updateSingupForm = (event) => {
    let obj = {}
    obj[event.target.name] = event.target.value
    this.setState({ signupForm: { ...this.state.signupForm, ...obj } });
  }
  handleGender = (event, newGender) => {
    this.setState({ signupForm: { ...this.state.signupForm, gender: newGender } })
  }
  signup = async () => {
    const { nationalId, isAtba } = this.state.signupForm
    this.setState({ loading: true })

    if(!isAtba && nationalId) {
      if (!utils.isValidIranianNationalCode(nationalId)) {
        this.setState({ loading: false })
        return this.openSnackbar('کدملی اشتباه است')
      }
    }
    

    let result = await axios.post(utils.urls.signupURL, {
      ...this.state.signupForm,
      gender: this.state.signupForm.gender === 'true',
      mobile: this.state.usernameVal,
      isAtba: isAtba
    }, {
      headers: {
        'x-access-token': this.state.tempToken
      }
    }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return
    // console.log(result)
    let { token, patient, blogToken } = result.data;

    Matrix.setToken(token);
    localStorage.setItem("blogToken", blogToken);
    setTimeout(() => this.setState({ redirect: this.redirectToChatURL() }), 100)
  }

  setAtbaCode = () => this.setState({signupForm: {...this.state.signupForm, isAtba: !this.state.signupForm.isAtba} })

  captcha = () => {
    if (!this.state.captcha.svg) return

    return (
      <div className="captcha">
        <div className="hint">لطفا عدد داخل تصویر را در فیلد زیر وارد کنید</div>
        <div className="captchaContent">
          <input name="captchaCode" autoComplete="off" type="number" placeholder="عدد تصویر را وارد کنید" value={this.state.captchaCodeVal} onChange={this.handleChange} />
          <div className="img" dangerouslySetInnerHTML={{ __html: this.state.captcha.svg }}></div>
          <button onClick={this.apiGetCaptcha} ref={this.captchaBtn}><ReplayIcon /></button>
        </div>
      </div>
    )
  }

  UISendCodeForm = () => {
    return (
      <div class="cols smsForm" >
        <div class="hint">لطفا کد ارسال شده به شماره <span>{this.state.usernameVal}</span> را وارد نمایید</div>
        <Button onClick={this.wrongNumber} variant="outlined" style={{ borderRadius: '23px', marginBottom: '10px' }}>
          شماره همراه اشتباه است؟
                <EditTwoToneIcon fontSize="small" />
        </Button>
        <input id="smsCode" name="smsCode" placeholder="" type="text" value={this.state.smsCodeVal} onChange={this.handleChange} />
        {this.captcha()}
        <div class="button" onClick={this.sendCode}>تایید کد</div>
        <button className="contact-us-btn">
          <a href={whatsappLink}>ارتباط با پشتیبانی</a>
        </button>


        {this.state.loading && <div class="smsFormLoading"><Loading /></div>}
      </div>
    )
  }
  UIInsertMobileForm = () => {
    return (
      <div class="cols mobileForm" >
        <span>شماره همراه تان را وارد نمایید</span>
        <input id="user-name" name="username" placeholder="09123456789" type="text" value={this.state.usernameVal} onChange={this.handleChange} />
        {this.captcha()}
        <div class="button" onClick={this.sendNumber}>ورود</div>
        <button className="contact-us-btn">
          <a href={whatsappLink}>ارتباط با پشتیبانی</a>
        </button>
        {this.state.loading && <div class="mobileFormLoading"><Loading /></div>}
      </div>
    )
  }
  UISignupForm = () => {
    return (
      <>
        <h3 class="hint">فرم ثبت نام زیر را تکمیل نمایید</h3>
        <div class=" signupForm" >
          <div class='form-row'>
            <span class='kv-label'>نام</span>
            <input id="fname" name="fname" placeholder="نام" type="text" value={this.state.signupForm.fname} onChange={this.updateSingupForm} />
          </div>

          <div class='form-row'>
            <span class='kv-label'>نام خانوادگی</span>
            <input id="lname" name="lname" placeholder="نام خانوادگی" type="text" value={this.state.signupForm.lname} onChange={this.updateSingupForm} />
          </div>
          <div className='terms'>
            <div className='terms__checkbox'>
              <input id='isAtba' name='isAtba' type='checkbox' value={this.state.signupForm.isAtba} onChange={this.setAtbaCode} />
              <div>اتباع خارجی هستم</div>
            </div>
          </div>
          {
            this.state.signupForm.isAtba ? 
              <div className='form-row'>
                <span className='kv-label'>کد فراگیر</span>
                <input className='nationalId' id="nationalId" name="nationalId" placeholder="کد فراگیر" type="number" value={this.state.signupForm.nationalId} onChange={this.updateSingupForm} />
              </div> : 
              <div class='form-row'>
              <span class='kv-label'>کد ملی</span>
              <input class='nationalId' id="nationalId" name="nationalId" placeholder="کد ملی" type="number" value={this.state.signupForm.nationalId} onChange={this.updateSingupForm} />
            </div>
          }
          <div class='form-row gender-row'>
            <span class='kv-label'>جنسیت</span>
            <ToggleButtonGroup
              value={this.state.signupForm.gender}
              exclusive
              onChange={this.handleGender}
              aria-label="text alignment"
            >
              <ToggleButton value="true" aria-label="male">
                <img src="/images/male.png" />
              </ToggleButton>
              <ToggleButton value="false" aria-label="female">
                <img src="/images/female.png" />
              </ToggleButton>
            </ToggleButtonGroup>
          </div>

          <div class="button" onClick={this.signup}>ثبت نام</div>

          {this.state.loading && <div class="smsFormLoading"><Loading /></div>}
        </div>
      </>
    )
  }

  apiGetCaptcha = async () => {
    if (this.captchaBtn.current) this.captchaBtn.current.disabled = true

    const res = await axios.get(utils.urls.captcha + `?serviceId=${this.state.formStep === 1 ? 'signup' : 'login'}`)
      .catch((e) => {
        console.log(e.response)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.openSnackbar(message)
      })

    if (this.captchaBtn.current) this.captchaBtn.current.disabled = false

    if (!res) return
    if (!res.data.success) {
      this.openSnackbar('خطایی رخ داده است')
      return
    }

    this.setState({
      captcha: {
        svg: res.data.captcha,
        hash: res.data.hash
      }
    })
  }

  render() {
    if (this.state.redirect) {
      // console.log(this.state.redirect, '===----====---===---===---')
      return <Redirect to={this.state.redirect} />
    }
    return (
      <div class="pageRoot">
        <Header title="ورود" showBackButton={false}></Header>
        <div class="loginContainer">
          {/* <h1>ورود به سامانه</h1> */}
          <div class=" cols" style={{ width: "90%", marginTop: '40px', flexWrap: 'nowrap' }}>
            {this.state.formStep === 1 && this.UIInsertMobileForm()} {/* insert mobile form */}
            {this.state.formStep === 2 && this.UISendCodeForm()} {/*insert the sent code*/}
            {this.state.formStep === 3 && this.UISignupForm()} {/*signup form*/}
          </div>
        </div>
        <Snackbar
          classes={{ root: 'ti-snackbar-root' }}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.open}
          onClose={this.handleClose}

        >
          <SnackbarContent
            message={this.state.snackMessage}
            classes={{ root: 'ti-snackbarcontent-root-default' }}
            action={this.closeAction}
          >

          </SnackbarContent>
        </Snackbar>
      </div>
    )
  }
}
export default Login